import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireinpuneforoutstationandlocal() {


const cardData = {
keyword: "Bus Hire in Pune For Outstation and Local",
headingDescription: "Ruturaj Enterprises provides dependable bus hire in Pune for both local transportation and outstation journeys, serving families, friends, corporate teams, schools, wedding groups, tourists and event organizers. With AC, non-AC, luxury and mini bus options, groups can choose a suitable vehicle according to passenger count, route and travel purpose. Whether it is local sightseeing, an airport transfer, picnic, school excursion, wedding function or a multi-day outstation tour, our bus rental services are designed for comfortable and organized group travel.",
topPlaces: [
{
title: "Kamshet",
description: "Kamshet is a popular destination for weekend escapes, adventure activities, lakeside outings and group picnics from Pune. A hired bus makes it convenient for families, friends, schools and corporate groups to travel together with luggage and activity equipment."
},
{
title: "Mulshi",
description: "Mulshi is known for its scenic hills, reservoir views and peaceful surroundings, making it suitable for picnics and group getaways. Bus rental services provide a practical transportation solution when larger groups want to travel together from Pune."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar attracts families, tourists and corporate groups with its viewpoints, valleys, markets and pleasant hill-station atmosphere. A comfortable bus rental from Pune is useful for sightseeing programs where several passengers need to travel together."
},
{
title: "Shirdi",
description: "Shirdi is a major pilgrimage destination visited by families, devotees and organized tour groups throughout the year. Hiring a bus from Pune allows the complete group to travel together with convenient space for luggage during a one-day or multi-day religious trip."
},
{
title: "Aurangabad",
description: "Aurangabad offers access to historic attractions and heritage destinations, making it suitable for educational tours, family holidays and group excursions. An outstation bus provides comfortable shared transportation for groups traveling from Pune over a longer road route."
},
{
title: "Dapoli",
description: "Dapoli is a coastal destination suited to family vacations, college trips, corporate outings and weekend holidays. A spacious rental bus is convenient for groups carrying luggage and planning multiple stops along the Konkan route."
},
{
title: "Bhor",
description: "Bhor is surrounded by scenic landscapes, dams, forts and countryside attractions, making it suitable for short local and nearby group excursions. A hired bus can simplify transportation for picnic groups, families and organizations departing from Pune."
},
{
title: "Nashik",
description: "Nashik combines temples, vineyards, scenic locations and cultural attractions, giving groups several options for a planned tour. Bus hire from Pune is suitable for family trips, pilgrimage tours, corporate outings and organized sightseeing programs."
},
{
title: "Kolad",
description: "Kolad is well known for outdoor recreation, river activities and adventure-focused group trips. A bus rental makes it easier for friends, corporate teams and youth groups to travel together while carrying necessary bags and equipment."
},
{
title: "Panhala",
description: "Panhala provides a mix of historical attractions, fort architecture and scenic surroundings near Kolhapur. Groups from Pune can use an outstation bus for a comfortable journey and organized sightseeing across the destination."
}
],
services: [
{
name: "Bus Hire Pune",
description: "Bus hire in Pune offers a convenient transportation solution for families, tourists, organizations, schools and event groups. Ruturaj Enterprises can arrange suitable buses for local movement, sightseeing, functions, airport transfers and longer road journeys based on group requirements."
},
{
name: "Bus Rental Pune",
description: "Bus rental services in Pune are suitable for short-duration requirements as well as full-day and multi-day travel plans. Groups can select an appropriate vehicle for local transportation, weekend tours, corporate programs, weddings, picnics and outstation journeys."
},
{
name: "Bus Booking Pune",
description: "Bus booking in Pune can be planned according to the number of passengers, route, travel duration and purpose of the trip. Advance arrangements are useful for school tours, weddings, corporate events, family vacations, sightseeing and organized group travel."
},
{
name: "Local Bus Hire Pune",
description: "Local bus hire in Pune is useful for city transportation, sightseeing, events, school activities, weddings and group transfers. Keeping passengers together in one bus helps simplify movement between multiple locations and reduces the need to coordinate several smaller vehicles."
},
{
name: "Outstation Bus Hire Pune",
description: "Outstation bus hire from Pune provides a comfortable option for groups traveling to destinations across Maharashtra and neighboring states. The service works well for family tours, pilgrimage trips, corporate travel, educational excursions and multi-day holiday itineraries."
},
{
name: "AC Bus Hire Pune",
description: "AC bus hire in Pune is a suitable choice when passenger comfort is a priority, particularly for longer journeys and summer travel. Air-conditioned buses can accommodate groups for weddings, corporate events, vacations, sightseeing and outstation tours."
},
{
name: "Non AC Bus Hire Pune",
description: "Non AC bus hire in Pune provides a practical group transportation option for budget-conscious travel requirements and shorter routes. It can be useful for school trips, local events, picnics, group transfers and selected outstation journeys."
},
{
name: "Luxury Bus Hire Pune",
description: "Luxury bus hire in Pune is designed for groups looking for an upgraded travel experience for premium tours, corporate programs, weddings and special occasions. Spacious interiors and comfortable seating make group transportation more convenient during longer journeys."
},
{
name: "Mini Bus Hire Pune",
description: "Mini bus hire in Pune is ideal for smaller groups that need more space than multiple cars but do not require a full-size bus. It works well for family outings, corporate transfers, school activities, airport transportation, picnics and local sightseeing."
},
{
name: "Tourist Bus Hire Pune",
description: "Tourist bus hire in Pune provides organized transportation for sightseeing tours, holiday groups and destination-based travel. Groups can travel together while following a planned itinerary covering multiple attractions without arranging separate vehicles."
},
{
name: "Bus for Family Trip Pune",
description: "A bus for family trips from Pune makes holiday transportation easier when relatives and extended family members are traveling together. Suitable seating and luggage capacity help keep the group together during weekend vacations, religious tours and longer family journeys."
},
{
name: "Bus for Group Travel Pune",
description: "Groups traveling from Pune can hire a bus for social tours, family gatherings, college programs, community trips and recreational outings. One shared vehicle provides better coordination and makes it easier for everyone to follow the same travel schedule."
},
{
name: "Bus for Wedding Pune",
description: "Wedding bus services in Pune are useful for transporting guests between homes, hotels, wedding venues and reception locations. Dedicated group transportation helps families coordinate guest movement efficiently while providing a comfortable option for local and destination wedding functions."
},
{
name: "Bus for Corporate Events Pune",
description: "Corporate event bus hire supports employee transportation for conferences, meetings, seminars, team outings, exhibitions and company celebrations. Groups can arrange transportation between offices, hotels, venues and other business locations according to the event schedule."
},
{
name: "Bus for School Trips Pune",
description: "School trip buses provide organized transportation for students, teachers and accompanying staff traveling to educational or recreational destinations. Bus arrangements can support museum visits, nature excursions, historical tours, picnics and longer educational journeys."
},
{
name: "Bus for Picnic Pune",
description: "A bus for picnics from Pune is convenient for families, schools, colleges, offices and social groups planning a day trip. Everyone can travel together with food, bags and picnic supplies while maintaining a coordinated departure and return schedule."
},
{
name: "Bus for Airport Pickup Pune",
description: "Bus services for airport pickup in Pune are useful when a large family, corporate team or tour group arrives together with multiple pieces of luggage. A suitable-capacity bus can simplify transfers between Pune Airport, hotels, offices and other destinations."
},
{
name: "Bus for Local Sightseeing Pune",
description: "Local sightseeing bus hire in Pune allows groups to visit multiple attractions without arranging separate cars for each family or traveler. It is suitable for city tours, cultural visits, school excursions, family outings and organized group sightseeing."
},
{
name: "Affordable Bus Hire Pune",
description: "Affordable bus hire in Pune offers groups a practical way to manage transportation expenses by traveling together in one suitable vehicle. Different vehicle types and capacities allow customers to select an option according to their passenger count and trip requirements."
},
{
name: "Outstation Bus Rental Service Pune",
description: "Outstation bus rental services from Pune support travel to hill stations, pilgrimage destinations, beaches, heritage cities and major tourist locations. The arrangement is useful for one-day tours, weekend trips and multi-day itineraries requiring dependable group transportation."
},
{
name: "Local Bus Rental Service Pune",
description: "Local bus rental services in Pune can be arranged for sightseeing, weddings, corporate transfers, school activities, events and family functions. Having one dedicated vehicle helps groups move between multiple local locations in a coordinated and convenient manner."
},
{
name: "Bus Hire Near Me Pune",
description: "Customers searching for bus hire near them in Pune can choose a suitable vehicle according to group size, travel distance and purpose. Ruturaj Enterprises supports local and outstation transportation requirements for families, organizations, tourists, schools and event groups."
}
],
tableData: [
["Bus Hire Pune", "Bus Rental Pune"],
["Bus Booking Pune", "Local Bus Hire Pune"],
["Outstation Bus Hire Pune", "AC Bus Hire Pune"],
["Non AC Bus Hire Pune", "Luxury Bus Hire Pune"],
["Mini Bus Hire Pune", "Tourist Bus Hire Pune"],
["Bus for Family Trip Pune", "Bus for Group Travel Pune"],
["Bus for Wedding Pune", "Bus for Corporate Events Pune"],
["Bus for School Trips Pune", "Bus for Picnic Pune"],
["Bus for Airport Pickup Pune", "Bus for Local Sightseeing Pune"],
["Affordable Bus Hire Pune", "Outstation Bus Rental Service Pune"],
["Local Bus Rental Service Pune", "Bus Hire Near Me Pune"]
],
whychoose: [
{
WhyChooseheading: "Local and Outstation Flexibility",
WhyChoosedescription: "Ruturaj Enterprises supports both Pune city transportation and longer outstation journeys, making the service suitable for different travel plans. Groups can use the same convenient booking approach for sightseeing, events, holidays and destination travel."
},
{
WhyChooseheading: "Choice of Bus Types",
WhyChoosedescription: "AC, non-AC, luxury and mini bus options provide flexibility for different budgets, passenger counts and comfort preferences. Selecting the right vehicle helps create a more practical transportation arrangement for every group."
},
{
WhyChooseheading: "Ideal for Large Groups",
WhyChoosedescription: "Traveling together in a dedicated bus keeps families, friends, employees, students and tourists organized throughout the journey. It also reduces the coordination involved in managing several separate cars."
},
{
WhyChooseheading: "Useful for Every Occasion",
WhyChoosedescription: "Bus hire can support weddings, corporate events, school excursions, picnics, family vacations, airport transfers and sightseeing programs. This makes it a versatile option for both planned functions and recreational travel."
},
{
WhyChooseheading: "Comfortable Journey Planning",
WhyChoosedescription: "Vehicle selection can be based on passenger strength, route length, luggage requirements and trip duration. This helps groups choose a transportation arrangement that matches the practical needs of their itinerary."
},
{
WhyChooseheading: "Convenient Group Coordination",
WhyChoosedescription: "A dedicated bus allows passengers to follow a common departure, arrival and sightseeing schedule. Coordinated group movement is particularly useful for weddings, school trips, corporate programs and multi-stop tours."
},
{
WhyChooseheading: "Suitable for Different Budgets",
WhyChoosedescription: "With multiple bus categories available, travelers can consider an option that fits their comfort expectations and transportation budget. Shared group travel can also be more practical than arranging numerous individual vehicles."
},
{
WhyChooseheading: "Practical Pune Travel Solution",
WhyChoosedescription: "For groups starting from Pune, bus rental provides an organized way to handle local movement as well as long-distance travel. Ruturaj Enterprises focuses on making group transportation convenient for holidays, functions, tours and regular travel requirements."
}
]
};






const faqData = [
{
question: "Can I hire a bus in Pune for both local and outstation travel?",
answer: "Bus rental in Pune can be arranged for local sightseeing, events, family functions, corporate travel, and outstation journeys. Ruturaj Enterprises can help select a suitable vehicle according to the number of passengers, route, luggage, trip duration, and specific transportation requirements."
},
{
question: "What is the advantage of hiring a bus for group travel in Pune?",
answer: "A dedicated bus allows a large group to travel together instead of managing multiple cars or other transport options. It simplifies pickup and drop arrangements, luggage handling, route coordination, scheduled stops, and overall group movement during local as well as outstation trips."
},
{
question: "Can I hire a bus for local sightseeing in Pune?",
answer: "Local bus rental is suitable for sightseeing programs, school excursions, family outings, corporate activities, weddings, and events within Pune and nearby areas. The itinerary can be organized around the group's preferred locations, pickup points, sightseeing duration, and return schedule."
},
{
question: "Which outstation destinations can I travel to by bus from Pune?",
answer: "A rented bus from Pune can be used for trips to destinations such as Mumbai, Lonavala, Mahabaleshwar, Nashik, Kolhapur, Shirdi, Goa, Aurangabad, Gujarat, Rajasthan, and other cities or tourist destinations. The vehicle can be selected according to the distance, group size, and travel plan."
},
{
question: "Can families hire a bus in Pune for an outstation trip?",
answer: "Families traveling with relatives and children can choose a private bus when the group is large enough to require dedicated transportation. Everyone can stay together during the journey while carrying luggage and coordinating meal breaks, sightseeing stops, and return timings more conveniently."
},
{
question: "Is bus rental in Pune available for corporate travel?",
answer: "Corporate organizations can arrange buses for employee transportation, team outings, conferences, meetings, training programs, and company events. A dedicated bus provides coordinated group movement and can be planned around office schedules, event timings, pickup locations, and destination requirements."
},
{
question: "Can I book an AC bus for local or outstation travel from Pune?",
answer: "An AC bus can be considered when passengers prefer additional comfort during local sightseeing or longer outstation journeys. Ruturaj Enterprises can help identify an appropriate vehicle based on passenger capacity, route, luggage requirements, journey duration, and comfort preferences."
},
{
question: "What bus seating capacity should I choose for my group?",
answer: "The ideal seating capacity depends on the number of travelers and the amount of luggage being carried. Smaller groups may require a compact vehicle, while larger parties can consider higher-capacity buses. Vehicle selection should also account for journey duration and desired passenger comfort."
},
{
question: "Can I hire a bus for a one-day local or outstation trip from Pune?",
answer: "A one-day bus rental can be planned for local sightseeing as well as suitable nearby destinations. The schedule can be structured around departure and return timings, selected attractions, meal breaks, and the group's preferred itinerary to make the most of the available travel hours."
},
{
question: "Why choose Ruturaj Enterprises for bus hire in Pune?",
answer: "Ruturaj Enterprises provides group transportation solutions for both local and outstation journeys from Pune. Bus selection can be matched with passenger count, route, luggage, trip duration, and travel purpose, making it easier to organize transportation for sightseeing, functions, corporate programs, family trips, and group tours."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Prakash Jagtap",
feedback:
"We hired a bus from Ruturaj Enterprises for an outstation family trip from Pune. Having one vehicle for the complete group made it much easier to coordinate luggage, stops, and travel timings. The arrangement was convenient and worked well for our large group.",
rating: 5
},
{
id: 2,
name: "Miss. Manasi Patil",
feedback:
"Our company needed group transportation for a local event in Pune, and Ruturaj Enterprises arranged a suitable bus for us. Everyone could travel together from the pickup point to the venue, which made the day's transportation simple and well organized.",
rating: 5
}
];











































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire in Pune For Outstation and Local",
  "image": "https://ruturajenterprises.com/assets/images/bus-hire-in-pune-for-outstation-and-local.webp",
  "description":
    "Bus Hire in Pune For Outstation and Local travel, suitable for family trips, group tours, weddings, corporate events, school outings, picnics, sightseeing and long-distance journeys. Ruturaj Enterprises provides comfortable bus rental options including AC, non AC, luxury, mini and tourist buses with spacious seating, experienced drivers, flexible rental plans and convenient pickup arrangements for local Pune travel as well as outstation destinations.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/bus-hire-in-pune-for-outstation-and-local"
  }
};

    return (
        <div>

<Helmet>
  <title>
    Bus Hire in Pune For Outstation and Local | Bus Hire Pune | +91 9763381382
  </title>

  <meta
    name="description"
    content="Bus Hire in Pune For Outstation and Local travel for family trips, group tours, weddings, corporate events, school trips and sightseeing. Choose AC, Non AC, luxury, mini and tourist buses from Ruturaj Enterprises."
  />

  <meta
    name="keywords"
    content="Bus Hire Pune, Bus Rental Pune, Bus Booking Pune, Local Bus Hire Pune, Outstation Bus Hire Pune, AC Bus Hire Pune, Non AC Bus Hire Pune, Luxury Bus Hire Pune, Mini Bus Hire Pune, Tourist Bus Hire Pune, Bus for Family Trip Pune, Bus for Group Travel Pune, Bus for Wedding Pune, Bus for Corporate Events Pune, Bus for School Trips Pune, Bus for Picnic Pune, Bus for Local Sightseeing Pune, Bus for Pune Darshan, Bus for Airport Pickup Pune, Bus for Airport Drop Pune, Bus for Outstation Tour Pune, Bus for Family Tour Pune, Bus for Group Tour Pune, Bus for Corporate Travel Pune, Bus for Wedding Guests Pune, Wedding Guest Bus Hire Pune, Bus for Marriage Function Pune, Corporate Bus Rental Pune, Corporate Bus Hire Pune, Corporate Bus Booking Pune, School Trip Bus Rental Pune, School Picnic Bus Hire Pune, Picnic Bus Rental Pune, Tourist Bus Rental Pune, Tourist Bus Booking Pune, AC Bus Rental Pune, Non AC Bus Rental Pune, Luxury Bus Rental Pune, Mini Bus Rental Pune, Local Bus Rental Pune, Outstation Bus Rental Pune, Outstation Bus Rental Service Pune, Bus Rental Service Pune, Bus Hire Service Pune, Bus Booking Service Pune, Bus on Rent Pune, Bus on Rent for Local Travel Pune, Bus on Rent for Outstation Pune, Affordable Bus Rental Pune, Comfortable Bus Hire Pune, Premium Bus Hire Pune, Bus Hire Near Me Pune, Bus Rental for One Day Trip Pune, Bus Rental for Multi Day Trip Pune, Bus for Group Tour Pune, Bus for Family Vacation Pune, Bus for Corporate Events Pune, Bus for Wedding Events Pune, Bus for Religious Tour Pune, Bus for Temple Tour Pune, Bus for Maharashtra Tour Pune, Bus for Goa Trip Pune, Bus for Mumbai Trip Pune, Bus for Lonavala Trip Pune, Bus for Mahabaleshwar Trip Pune, Bus for Nashik Trip Pune, Bus for Shirdi Trip Pune, Bus for Kolhapur Trip Pune, Bus for Konkan Trip Pune, Ruturaj Enterprises Bus Hire Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/45.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Bushireinpuneforoutstationandlocal ;